import { INote, NotesService } from "../../services";

class NoteListController implements ng.IComponentController {
    private sortType: string;
    private search: string;
    private notes: INote[];
    private filteredNotes: INote[];
    private selectedTag: string;
    private currentNote: INote;

    private notesService: any;

    constructor(
        private $filter: any,
        private NotesService: NotesService,
    ) {
        'ngInject';
        this.notesService = NotesService;
    }

    public $onInit = () => {
        this.sortType = 'createdOn';
        this.filter();
    }

    filter(): void {
        this.filteredNotes = this.$filter('filter')(this.notes, (note: INote): boolean => {
            if (!!this.selectedTag) {
                return note.tags.indexOf(this.selectedTag) !== -1;
            } else {
                return true;
            }
        });
    }

    getNoteAuthorName(note: INote) {
        if (note.accountName) return note.accountName;
        if (note.employeeDisplayName) return note.employeeDisplayName;
        if (note.applicantName) return note.applicantName;
        return '';
    }

    // addNoteModal() {
    //     this.currentNote = null;
    //     (<any>$('#noteModal')).modal('show');
    // }

    // submitNote(item) {
    //     var newNote = item;
    //     newNote.date = new Date(Date.now());
    //     // newNote.accountId = this.account.id;

    //     if (newNote.id == null) {
    //         this.notesService.post(newNote).then(result => {
    //             this.notes.push(result);
    //         });
    //     } else {
    //         this.notesService.put(newNote.id, newNote);
    //     }

    //     (<any>$('#noteModal')).modal('hide');
    // }
}

export const noteListComponent = {
    bindings: {
        notes: '<',
        noteTags: '<'
    },
    controller: NoteListController,
    template: require('./note.list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/notes/note.list.component.ts